var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NamedTabs',{attrs:{"tabs":_vm.tabs},on:{"change":_vm.onTabChange,"input":_vm.onTabInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }